import { ColumnDef, Cell } from "@tanstack/react-table";
import { DuesRatesRow } from "../types";
import Tooltip from "@/components/Tooltip";
import { renderStatusIcon } from "@/pages/billing/dues-management/manage-products/annual-national-rates/_utils";
import { Row } from "@tanstack/react-table";
import { EditableInputType } from "@/components/Table/EditableCell";
import classNames from "classnames";
import ActionCell from "@/pages/billing/dues-management/manage-products/annual-national-rates/_components/ActionCell";

interface GetColumnsProps {
  tableData: DuesRatesRow[];
  rowSelected: number;
  handleEditRate: (value: string, cell: Cell<DuesRatesRow, unknown>) => void;
  canManageDuesRates: boolean;
  setOpenEditRateModal: (open: boolean) => void;
  setRowSelection: (rowSelection: any) => void;
  currentYear: number;
}

export const getColumns = ({
  tableData,
  rowSelected,
  handleEditRate,
  canManageDuesRates,
  setOpenEditRateModal,
  setRowSelection,
  currentYear
}: GetColumnsProps): ColumnDef<DuesRatesRow, any>[] => {
  const isAllFinalized = tableData.every((row) => row.finalized);
  return [
    {
      header: "Classification",
      accessorKey: "classification",
      enableSorting: true,
      cell: ({ row }) => {
        return (
          <Tooltip
            variant="plain"
            supportingText={row.original.classificationDescription}
            color="black"
            menuCorner="end-start"
            anchorCorner="start-start"
          >
            {row.original.classification}
          </Tooltip>
        );
      },
      meta: {
        className: isAllFinalized || !canManageDuesRates ? "" : "pl-0",
        headerClassName: classNames("max-md:hidden", isAllFinalized || !canManageDuesRates ? "" : "-ml-4")
      }
    },
    {
      header: `${currentYear} Rate`,
      accessorKey: "rate_current_year",
      enableSorting: false,
      meta: {
        editable: (row: Row<DuesRatesRow>) => !row.original.finalized,
        editableInputType: "currency" as EditableInputType,
        className: "!py-0 min-w-[150px]",
        editableClassName: classNames("text-left -ml-2", {
          "pointer-events-none": rowSelected !== 0 || !canManageDuesRates
        }),
        onEdit: handleEditRate,
        editableIcon: (cell: Cell<DuesRatesRow, unknown>) => {
          const { status, statusMessage } = cell.row.original;
          return status ? renderStatusIcon(status, statusMessage) : null;
        }
      }
    },
    {
      header: `${currentYear - 1} Rate`,
      accessorKey: "rate_previous_year",
      enableSorting: false
    },
    {
      header: `${currentYear - 2} Rate`,
      accessorKey: "rate_previous_year_2",
      enableSorting: false
    },
    {
      header: "Additional Information",
      accessorKey: "notes",
      enableSorting: false,
      size: 450,
      meta: {
        headerClassName: "max-sm:inline"
      }
    },
    {
      header: "Modified",
      accessorKey: "updatedAt",
      enableSorting: false
    },
    {
      header: "",
      id: "actions",
      accessorKey: "actions",
      enableSorting: false,
      cell: (cell) => (
        <ActionCell
          isEditable={rowSelected === 0 && !cell.row.original.finalized && canManageDuesRates}
          cell={cell}
          setOpenEditRateModal={setOpenEditRateModal}
          setRowSelection={setRowSelection}
        />
      ),
      meta: {
        className: "!py-0 "
      },
      size: 10
    }
  ];
};
